/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Dialogue_List_Export_Event_Start_After_EndInputs */



/**
* | output |
* | --- |
* | "Event {index} has a start time greater than its end time. Would you like to ABORT your export?" |
*
* @param {Dialogue_List_Export_Event_Start_After_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_event_start_after_end = /** @type {((inputs: Dialogue_List_Export_Event_Start_After_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Event_Start_After_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`L'événement ${i?.index} a une heure de début supérieure à l'heure de fin.
 Souhaitez-vous ABANDONNER l'exportation ?`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Das Ereignis ${i?.index} hat eine Startzeit, die nach der Endzeit liegt.
Möchten Sie den Export abbrechen?`)
	if (locale === "it") return /** @type {LocalizedString} */ (`L'evento ${i?.index} ha un orario di inizio successivo all'orario di fine.
Vuoi ANNULLARE l'esportazione?`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие ${i?.index} имеет время начала, превышающее время окончания.
Вы хотите ОТМЕНИТЬ экспорт?`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El evento ${i?.index} tiene una hora de inicio mayor que su hora de finalización.
¿Desea cancelar la exportación?`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件 ${i?.index} 的开始时间大于结束时间。

是否要中止导出？`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント ${i?.index} の開始時刻が終了時刻よりも後になっています。
エクスポートを中止しますか?`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट ${i?.index} का प्रारंभ समय उसके समाप्ति समय से अधिक है।
क्या आप अपना निर्यात रद्द करना चाहेंगे?`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`O evento ${i?.index} tem um horário de início posterior ao seu horário de término.
Deseja CANCELAR a exportação?`)
	return /** @type {LocalizedString} */ (`Event ${i?.index} has a start time greater than its end time.
 Would you like to ABORT your export?`)
});